import React from "react"
// import 'bootstrap/dist/css/bootstrap.min.css'
import './Modal.css'
import {Button}  from 'react-bootstrap'


export default class Modal extends React.Component{
    state= {
        isOpen: false
    }

    render() {
        return (
            <React.Fragment>
                <Button 
                    variant="secondary" onClick={() => this.setState({ isOpen: true })}>About App (modal)
                </Button>

               {this.state.isOpen &&  <div className="modal">
                    <div className="modal-body">
                        <h1>Une brève description des objectifs de l'Application</h1>
                        
                        <ul>React is a JavaScript library for building user interfaces.</ul>
                        <li> React Router,</li>
                        <li> React PropTypes,</li>
                        <li> React Bootstrap,</li>
                        <li> React Hooks "cycle de vie du composant",</li>
                        <li> Hooks: useState / useContext / useRef ...</li>
                        <li> Echanges entre composants,</li>
                        <li> Fetch Data from API with useEffect,</li>
                        <li> API: <br/>
                        https://dog.ceo/api/<br/>
                        https://jikan1.p.rapidapi.com/<br/>
                        </li>
                        <br/>
                        <Button variant="secondary" onClick={() => this.setState({ isOpen: false })}>Close</Button>
                     </div>
                </div>}
            </React.Fragment>
        )
    }
}